import { API_URLs } from "../../utilities/API_URLs"
import iAxios from "../../utilities/axios/axios-setup"
import { Http } from "../../utilities/axios/http"

export const getRoleForSelect = (searchKey: string) => {
  return iAxios.get(API_URLs.settings.roles.getRoleSelect + '?order[id]=asc&page=1&pagination=false&name=' + searchKey)
  .then(r => r.data)
  .catch(e => null)
}

export class GetUserRoleService {
  static getRoles = async (params?: any) => {
    try {
      return Http.get(API_URLs.settings.roles.getRoleSelect, params);
    } catch (error) {
      return error
    }
  }
}